import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/components/shared/api.service';
import { SharedService } from 'src/app/components/shared/shared.service';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrls: ['./contract-details.component.scss']
})
export class ContractDetailsComponent implements OnInit {
  contractCode = '';
  isLoading = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private _api: ApiService,
    private _shared: SharedService
  ) {}

  ngOnInit(): void {
    this.contractCode = this.route.snapshot.queryParamMap.get('contract_code') || '';
    if (!this.contractCode) {
      this.errorMessage = 'contract_code query parameter is required.';
      return;
    }
    this.verifyContract();
  }

  retryVerification(): void {
    this.errorMessage = '';
    this.verifyContract();
  }

  verifyContract(): void {
    this.isLoading = true;
    this.errorMessage = '';
    const params = {
      contract_code: this.contractCode,
      show_toaster_messages: false
    };

    this._api.api(params, 'auth/get_open_contract_info', 'get')
      .subscribe((data: any) => {
        this.isLoading = false;
        if (!data || data.is_error) {
          this.errorMessage = data?.original_text || data?.err || 'Contract does not exist.';
          return;
        }

        const redirectUrl = data.redirect_url || data.redirectUrl || data.redirect || data?.data?.redirect_url || data?.data?.redirectUrl;
        if (redirectUrl) {
            window.open(redirectUrl, '_self');
          return;
        }

        this.errorMessage = 'Contract exists but no redirect URL was returned.';
      }, (error: any) => {
        this.isLoading = false;
        this.errorMessage = error?.error || error?.message || 'Unable to verify contract at this time.';
      });
  }
}
